import { makeAutoObservable } from 'mobx'
import { AttachmentType } from '../types'

class AttachmentModel {
   attachmentId: string
   name: string | undefined | null
   mimeType: string | undefined | null
   sizeInBytes: number | undefined | null
   url: string
   preSignedUrl: string
   private _preSignedDownloadUrl!: string | null

   private constructor(attachment: AttachmentType) {
      this.attachmentId = attachment.attachmentId
      this.name = attachment.name
      this.mimeType = attachment.mimeType
      this.sizeInBytes = attachment.sizeInBytes
      this.url = attachment.url
      this.preSignedUrl = attachment.preSignedUrl

      this._preSignedDownloadUrl = attachment.preSignedDownloadUrl ?? null

      makeAutoObservable(this, {}, { autoBind: true })
   }

   get preSignedDownloadUrl(): string | null {
      return this._preSignedDownloadUrl
   }

   setPreSignedDownloadUrl(preSignedDownloadUrl: string | null): void {
      this._preSignedDownloadUrl = preSignedDownloadUrl
   }

   setPreSignedUrl(preSignedUrl: string) {
      this.preSignedUrl = preSignedUrl
   }

   setAttachmentId = (attachmentId: string) => {
      this.attachmentId = attachmentId
   }

   update(attachment: AttachmentType): void {
      this.attachmentId = attachment.attachmentId
      this.name = attachment.name
      this.mimeType = attachment.mimeType
      this.sizeInBytes = attachment.sizeInBytes
      this.url = attachment.url
      this.preSignedUrl = attachment.preSignedUrl

      this._preSignedDownloadUrl = attachment.preSignedDownloadUrl ?? null
   }

   clearPresignedUrls(): void {
      this._preSignedDownloadUrl = null
      this.setPreSignedUrl('')
   }

   static createAttachmentModel = (remark: AttachmentType): AttachmentModel =>
      new AttachmentModel(remark)
}

export default AttachmentModel
